module.exports = __webpack_public_path__ + "static/PersonalLoan-NZ-F3-c36387c019a24b0ae0574f61af7a1518.webp";